import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import App from '../components/App';
import 'babel-polyfill';

const mapStateToProps = (state: any) => {
  return {
    user: state.app,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App as any);



// WEBPACK FOOTER //
// ./src/containers/App.tsx